import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'
import { MyURLSearchParams } from '../utils/url-search-params'

const BASE_URL = '/entity/storages'

class Create extends Base {
  private body = DomainSchema.Storage.pick({
    name: true,
    description: true,
    active: true,
  })

  private response = DomainSchema.Storage

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post(BASE_URL, body)
    return this.response.parse(data.result)
  }
}

class Update extends Base {
  private body = DomainSchema.Storage.pick({
    name: true,
    description: true,
    active: true,
  })

  private response = DomainSchema.Storage

  handle = async (id: string, body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.put(`${BASE_URL}/${id}`, body)
    return this.response.parse(data.result)
  }
}

class Search extends Base {
  private searchParams = z.object({
    search: z.string().optional(),
    active: z.boolean().optional(),
  })

  private response = z.array(DomainSchema.Storage)

  handle = (searchParams: z.infer<typeof this.searchParams>) => {
    return useQuery(['storage', 'search', { ...searchParams }], async () => {
      const queryParams = new MyURLSearchParams(searchParams).toString()
      const { data } = await this.axios.get(`${BASE_URL}?${queryParams}`)
      return this.response.parse(data.result)
    })
  }
}

class LoadOne extends Base {
  private response = DomainSchema.Storage

  handle = (id: string) => {
    return useQuery(['storage', 'load-one', { id }], async () => {
      const { data } = await this.axios.get(`${BASE_URL}/${id}`)
      return this.response.parse(data.result)
    })
  }
}

class DownloadCSV extends Base {
  handle = async (id: string) => {
    const { data } = await this.axios.get(`${BASE_URL}/${id}/export`)
    return data
  }
}

export default class extends Base {
  Create = new Create(this.axios).handle
  Update = new Update(this.axios).handle
  Search = new Search(this.axios).handle
  LoadOne = new LoadOne(this.axios).handle
  DownloadCSV = new DownloadCSV(this.axios).handle
}
